export default __webpack_public_path__ + "static/media/santo.7262aa1c.png";